import api from '../lib/axios';
export async function getDirectoryEntries(params) {
    const { data } = await api.get('/api/admin/directory', { params });
    return data;
}
export async function getDirectoryEntry(id) {
    const { data } = await api.get(`/api/admin/directory/${id}`);
    return data.data;
}
export async function createDirectoryEntry(body) {
    const { data } = await api.post('/api/admin/directory', body);
    return data.data;
}
export async function updateDirectoryEntry(id, body) {
    const { data } = await api.patch(`/api/admin/directory/${id}`, body);
    return data.data;
}
export async function deleteDirectoryEntry(id) {
    await api.delete(`/api/admin/directory/${id}`);
}
// --- Pro accounts linked to an entry ---
export async function getDirectoryMembers(id) {
    const { data } = await api.get(`/api/admin/directory/${id}/members`);
    return data;
}
export async function addDirectoryMember(id, body) {
    await api.post(`/api/admin/directory/${id}/members`, body);
}
export async function resendDirectoryMemberInvitation(id, userId) {
    await api.post(`/api/admin/directory/${id}/members/${userId}/resend-invitation`);
}
export async function removeDirectoryMember(id, userId) {
    await api.delete(`/api/admin/directory/${id}/members/${userId}`);
}
